import React, { PropTypes } from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import actions from "actions";

class CpdUserLocker extends React.Component {
  render() {
    const is_recorded = !!window.location.pathname.match(/recorded/);

    const {
      location: { pathname },
    } = this.props;

    return (
      <main className="site--width">
        <div className="container_cpd row">
          <h2 className="main_title">
            {is_recorded
              ? "RECORDED WEBINARS VIEWED"
              : "LIVE WEBINARS ATTENDED"}
          </h2>

          {this.props.children}
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CpdUserLocker);



// WEBPACK FOOTER //
// ./src/containers/CpdUser/CpdUserLocker.jsx